<template>
    <v-btn @click="onButtonClick" outlined>{{label}}</v-btn>
</template>

<script>
    export default {
        name: "Button",
        props: {
            name: {
                type: String
            },
            label: {
                type: String
            }
        },
        methods: {
            onButtonClick() {
                this.$emit('onclick:buttonClick', `${this.name}-button-click`);
            }
        }
    }
</script>

<style scoped>

</style>